/* eslint-disable */

import { Injectable } from '@angular/core';
import { CONSTANTS } from '../config.service';
import { GisService } from '../gis.service';
import { LoggerService } from '../logger.service';
import { PosterService } from '../poster.service';
import { PrefsService } from '../prefs.service';
import { SqlHelperService } from '../sql-helper.service';
import { TripSurveyService } from '../trip-survey.service';
import { UtilsService } from '../utils.service';
import { MatcherService } from './matcher.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class PrepopulateService {
  db;
  historyTable = 'prepopHistory';
  SECONDS_IN_A_DAY = 24 * 60 * 60;
  // code works with ranges of < 12 hours
  MAX_WITHIN_TIME_OF_DAY_SECONDS = this.SECONDS_IN_A_DAY / 4;
  numVehicles;

  constructor(
    private logger: LoggerService,
    private matcher: MatcherService,
    private poster: PosterService,
    private sqlHelper: SqlHelperService,
    private tripSurvey: TripSurveyService,
    private utils: UtilsService,
    private gis: GisService,
    private prefs: PrefsService
  ) {}

  getSurvey(question, surveyData) {
    const conditions = question.prepopulate;
    const self = this;
    this.logger.log('Prepop getSurvey, all conditions', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, question.name, conditions);
    if (!conditions) {
      return Promise.reject(null);
    }
    if (Array.isArray(conditions)) {
      let i = 0;
      const fns = conditions.map(
        (c) =>
          function () {
            self.logger.log('Prepop fn#', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, i++, question.name, 'with', c);
            return self.findSurvey(c, surveyData, question);
          }
      );
      this.logger.log('Prepop fns', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, fns.length);
      return this.utils.firstSerialPromise(fns);
    } else {
      return this.findSurvey(conditions, surveyData, question);
    }
  }

  proposing(prepopSurvey, activeSurveyId, questionName) {
    const conditionId = prepopSurvey.prepopConditions.hasOwnProperty('name')
      ? prepopSurvey.prepopConditions['name']
      : prepopSurvey.prepopConditions;
    const data = { fromId: prepopSurvey.id, toId: activeSurveyId, toQuestionName: questionName };
    return this.sqlHelper.getInsertPromise(this.db, this.historyTable, data).then(() =>
      this.logger.info('prepop proposed', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, Object.assign({}, data, { conditions: conditionId }))
    );
  }

  accepted(prepopSurvey, activeSurveyId, questionName) {
    const conditionId = prepopSurvey.prepopConditions.hasOwnProperty('name')
      ? prepopSurvey.prepopConditions['name']
      : prepopSurvey.prepopConditions;
    const data = { fromId: prepopSurvey.id, toId: activeSurveyId, toQuestionName: questionName };
    return this.sqlHelper.getUpdatePromise(this.db, this.historyTable, { accepted: 1 }, data).then(() =>
        this.logger.info('prepop accepted', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, Object.assign({}, data, { conditions: conditionId }))
    );
  }

  private findSurvey(singleSurveyCriteria, surveyData, question): Promise<any> {
    const current = singleSurveyCriteria.current;
    const previous = singleSurveyCriteria.previous;
    if (current && !this.matcher.conditionsMatch(current, surveyData)) {
      return Promise.reject('current N/A');
    }
    const s = surveyData;
    const { where, orderCols, orderBy } = this.getQuery(previous, s);

    this.addHasAnswerCondition(question, where);
    if (previous.last) {
      return this.tripSurvey.getLatestSurveyByPersonId(s.subjectPersonId, s.startTime).then((lastSurvey) => {
        if (!lastSurvey) {
          this.logger.log('no last survey', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE);
          return Promise.reject('no last survey');
        } else {
          where['id'] = lastSurvey.id;
          return this.findSurveyImpl(where, orderCols, orderBy, singleSurveyCriteria);
        }
      });
    } else {
      where['id_NE'] = s.id;
      where['subjectPersonId'] = s.subjectPersonId;
      return this.findSurveyImpl(where, orderCols, orderBy, singleSurveyCriteria);
    }
  }

  private findSurveyImpl(where, orderCols, orderBy, conditions): Promise<any> {
    this.logger.log('prepop findSurvey where', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, where, 'orderCols', orderCols, 'orderBy', orderBy);
    return this.tripSurvey.getPrepopSurvey(where, orderCols, orderBy).then((r) => {
      if (r === null) {
        return Promise.reject('Survey not found');
      } else {
        this.logger.log('prepop findSurvey', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, r);
        r['prepopConditions'] = conditions;
        return r;
      }
    });
  }

  private addHasAnswerCondition(question, where) {
    switch (question.type) {
      case 'radio':
      case 'button':
        where[question.name + this.sqlHelper.NOT_NULL] = true;
        break;
      case 'checkbox':
        var j = 0;
        var obj = {};
        while ('OR' + j in where) {
          j++;
        } // don't overwrite existing OR
        question.items.forEach((item, i) => {
          obj[item.dbField] = 1;
        }); // add all checkboxes that are available on the page and see if at least one is selected.
        where['OR' + j] = obj;
        break;
    }
  }

  private getQuery(
    conditions,
    surveyData,
    out = { where: {}, orderCols: [], orderBy: '' },
    notSuffix = 0,
    orSuffix = 0
  ): { where: Object; orderCols: Array<string>; orderBy: string } {
    if (!conditions) {
      return out;
    }

    if (Array.isArray(conditions)) {
      conditions.forEach((c) => {
        this.getQuery(c, surveyData, out, ++notSuffix, ++orSuffix);
      });
    } else {
      this.utils.throwForNotExactly1Key(conditions, ['any', 'all', 'not', 'field', 'fn', 'start', 'stop']);
      if ('all' in conditions) {
        this.getQuery(conditions.all, surveyData, out);
      } else if ('any' in conditions) {
        out.where['OR' + orSuffix] = this.getQuery(conditions.any, surveyData).where;
      } else if ('not' in conditions) {
        this.logger.log('prepop getQuery not', MSRemoteLoggerCategory.SURVEY_PREPOPULATE_SERVICE, notSuffix, conditions);
        out.where['NOT' + notSuffix] = this.getQuery(conditions.not, surveyData).where;
      } else if ('field' in conditions) {
        this.utils.throwForNotExactly1Key(conditions, ['is', 'in']);
        if ('is' in conditions) {
          this.addIsField(conditions, out.where);
        } else if ('in' in conditions) {
          this.addInField(conditions, out.where);
        }
      } else if ('fn' in conditions) {
        if (conditions['fn'] == 'usedOneOwnVehicle') {
          this.fn_addOneOwnVehicle(out.where);
        } else {
          throw 'Unhandled prepopulate fn "' + conditions['fn'] + '"';
        }
      } else if ('start' in conditions) {
        this.addTripConditions(true, conditions.start, surveyData, out);
      } else if ('stop' in conditions) {
        this.addTripConditions(false, conditions.stop, surveyData, out);
      }
    }

    return out;
  }

  private addTripConditions(isStart, conditions, surveyData, out = { where: {}, orderCols: [], orderBy: '' }) {
    const addOrderBy = function (ordering) {
      if (out.orderBy !== '') {
        out.orderBy += ',';
      }
      out.orderBy += `${ordering}`;
    };
    const aliasSuffix = isStart ? 'Start' : 'Stop';

    // these are in 'order by' order
    if ('withinMeters' in conditions) {
      const lat = surveyData[isStart ? 'startLat' : 'stopLat'];
      const lon = surveyData[isStart ? 'startLon' : 'stopLon'];
      const meters = conditions.withinMeters;
      const latRadius = this.gis.getInternalLatDegrees(meters);
      const avgLat = (surveyData['startLat'] + surveyData['stopLat']) / 2;
      const lonRadius = this.gis.getInternalLonDegrees(meters, avgLat);
      const lonCorrection = this.gis.getLonCorrectionFactor(this.gis.getFloatLatOrLon(avgLat));
      const alias = 'meters' + aliasSuffix;
      Object.assign(out.where, this.tripSurvey.getNearConditions(isStart, lat, lon, latRadius, lonRadius));
      out.orderCols.push(this.tripSurvey.getSquaredDistCol(isStart, lat, lon, lonCorrection) + ' AS ' + alias), addOrderBy(alias + ' ASC');
    }
    if ('withinMinutes' in conditions) {
      const col = isStart ? 'startTime' : 'stopTime';
      const seconds = conditions.withinMinutes * 60;
      const lowSeconds = surveyData[col] - seconds;
      const highSeconds = surveyData[col] + seconds;
      const alias = 'minutes' + aliasSuffix;
      out.where[col + '_BETWEEN'] = [lowSeconds, highSeconds];
      out.orderCols.push(`(abs(${col} - ${surveyData[col]})) AS ${alias}`);
      addOrderBy(`${alias} ASC`);
    }
    if ('withinTimeOfDayMinutes' in conditions) {
      const col = isStart ? 'startTime' : 'stopTime';
      const seconds = conditions.withinTimeOfDayMinutes * 60;
      const alias = 'timeOfDay' + aliasSuffix;

      if (seconds >= this.MAX_WITHIN_TIME_OF_DAY_SECONDS) {
        throw seconds + ' > MAX_WITHIN_TIME_OF_DAY_SECONDS of ' + this.MAX_WITHIN_TIME_OF_DAY_SECONDS;
      }

      let secondOfDay = surveyData[col] % this.SECONDS_IN_A_DAY;
      let lowSeconds = secondOfDay - seconds;
      let highSeconds = secondOfDay + seconds;
      let shift = 0;

      // out of day range? shift by 12 hours (timezone immaterial)
      if (lowSeconds < 0 || highSeconds > this.SECONDS_IN_A_DAY) {
        shift = this.SECONDS_IN_A_DAY / 2;
        secondOfDay = (surveyData[col] + shift) % this.SECONDS_IN_A_DAY;
        lowSeconds = secondOfDay - seconds;
        highSeconds = secondOfDay + seconds;
      }

      // hacking _BETWEEN...
      // the cast to integer got this working on Android - not sure why b/c typeof returned integer already
      // LT high worked, GT low didn't, so it looks like a typing issue...
      //out.orderCols.push(`typeof(((${col} + ${shift}) % ${this.SECONDS_IN_A_DAY})) AS wToDMto`);
      out.where[`cast((${col} + ${shift}) % ${this.SECONDS_IN_A_DAY} as integer)_BETWEEN`] = [lowSeconds, highSeconds];
      out.orderCols.push(`cast(((${col} + ${shift}) % ${this.SECONDS_IN_A_DAY}) - ${secondOfDay} as integer) AS ${alias}`);
      // for viewing computed value, may need to comment out the where term to get a result
      //out.orderCols.push(`((${col} + ${shift}) % ${this.SECONDS_IN_A_DAY}) AS wToDMv`);
      addOrderBy(`${alias} ASC`);
    }
    return out;
  }

  // starting with just what we're using - purpose* and mode
  // to generalize, schema.ts could handle this?
  // maybe look up question type, assuming it's constant per q name per survey (multiple copies of q in different branches)
  private addIsField(isFieldCondition, out) {
    const c = isFieldCondition;
    if (c.field === 'mode' || c.field == 'householders') {
      out[this.getCbCol(c.field, c.is)] = 1;
    } else if (c.field.startsWith('purpose') || c.field.startsWith('others')) {
      out[c.field] = c.is;
    } else {
      throw 'Unexpected isFieldCondition: ' + c;
    }
  }

  private addInField(inFieldCondition, out) {
    const c = inFieldCondition;
    if (c.field === 'mode' || c.field == 'householders') {
      const f = {};
      c.in.forEach((v) => {
        f[this.getCbCol(c.field, v)] = 1;
      });
      out['OR'] = f;
    } else if (c.field.startsWith('purpose') || c.field.startsWith('others')) {
      out[`${c.field}_IN`] = c.in;
    } else {
      throw 'Unexpected inFieldCondition: ' + c;
    }
  }

  private getCbCol(name, value) {
    return `_CB_${name}_${value}`;
  }

  private fn_addOneOwnVehicle(where) {
    if (this.numVehicles == 0) {
      return;
    }
    // modes 6-15 are owned vehicles
    // we're relying on the server setting these in order, a little fragile?
    // also in the matchers provider for current surveys
    const start = 6;
    let addModesCol = '(';
    for (let veh = start; veh < start + this.numVehicles; veh++) {
      if (veh > start) {
        addModesCol += '+';
      }
      addModesCol += this.getCbCol('mode', veh);
    }
    addModesCol += ')' + this.sqlHelper.LITERAL;
    where[addModesCol] = 1;
  }

  initialize() {
    return (
      this.sqlHelper
        .createDb({ name: CONSTANTS.mainFrontEndDbName, location: 'default', androidDatabaseProvider: 'system', androidLockWorkaround: 1 })
        .then((db) => {
          this.db = db;
          return this.sqlHelper.createTablePromise(
            this.db,
            'CREATE TABLE IF NOT EXISTS ' +
              this.historyTable +
              ' ( ' +
              'id INTEGER primary key autoincrement, ' +
              'fromId INTEGER, ' +
              'toId INTEGER, ' +
              'toQuestionName TEXT, ' +
              'accepted INTEGER DEFAULT 0' +
              ')'
          );
        })
        // setting on startup to use sync'ly
        .then((ignored) => this.prefs.getPromise('numVehicles'))
        .then((numVehs) => {
          this.numVehicles = numVehs;
          return Promise.resolve();
        })
    );
  }
}
